<script setup lang="ts">
  import { Text, IconClose, IconButton } from "@ui-kit";
  import { type ItemWithSizeList } from "@src/hooks";
  import { CounterWithButton, ProductMiniCard } from "@src/components";

  const { item } = defineProps<{ item: ItemWithSizeList }>();
  const emit = defineEmits<{ (e: "update", item: ItemWithSizeList): void; (e: "remove", id: string): void }>();

  const handleUpdate = (id: string, count: number) => {
    emit("update", {
      ...item,
      sizeList: item.sizeList.map((size) => (size.item_id === id ? { ...size, count } : size)),
    });
  };

  const handleRemove = () => {
    emit("remove", item.item_id);
  };
</script>

<template>
  <div class="order-create-item" data-testid="order-create-item">
    <IconButton class="close" @click="handleRemove">
      <IconClose />
    </IconButton>
    <ProductMiniCard :image="item.image_url" :name="item.title" :article="item.article" :color="item.color" />
    <div class="sizes">
      <div class="row">
        <Text font="body-regular-14" color="secondary">{{ $t("Размер") }}</Text>
        <Text font="body-regular-14" color="secondary">{{ $t("Кол-во") }}</Text>
      </div>
      <div class="row" v-for="itemSize in item.sizeList" :key="itemSize.item_id">
        <Text font="body-medium-16">{{ itemSize.size }}</Text>
        <CounterWithButton :count="itemSize.count" @change="(count) => handleUpdate(itemSize.item_id, count)" />
      </div>
    </div>
  </div>
</template>

<style scoped>
  .order-create-item {
    display: flex;
    flex-direction: column;
    gap: 24px;
    background-color: var(--sf-base-background-primary);
    border-radius: 16px;
    padding: 12px;
    position: relative;

    .close {
      position: absolute;
      top: 8px;
      right: 8px;
    }

    & :deep(.item) {
      padding-right: 36px;
    }

    .sizes {
      display: flex;
      flex-direction: column;

      .row {
        display: flex;
        flex: 1;
        align-items: center;
        text-align: center;
        padding: 8px 0;

        & > :first-child {
          flex: 1;
        }

        & > :last-child {
          flex: 0 160px;
        }
      }
    }
  }
</style>
